import type { FC } from "react";
import { IconButton, Stack, Typography } from "~/common/mui";
import type { InvoiceInfoData } from "~/domains/orders/types/models";
import LaunchIcon from "@mui/icons-material/Launch";
import { useTranslation } from "react-i18next";
import { TooltipWithArrow } from "~/common/components/TooltipWithArrow";

export const TrackerV2: FC<{ data: InvoiceInfoData }> = (props) => {
  const { t } = useTranslation();
  return (
    <Stack sx={{ alignItems: "center", flexDirection: "row" }}>
      <Typography>
        {props.data.shippingPartnerName &&
        props.data.shippingPartnerName !== "-" &&
        props.data.shippingPartnerName !== ""
          ? props.data.shippingPartnerName
          : props.data.shippingPartnerId}
      </Typography>
      {props.data.trackingUrl && (
        <TooltipWithArrow title={t("orderDetails.track.shipment")} placement="top" arrow>
          <IconButton size="small" color="primary" href={props.data.trackingUrl} target="_blank">
            <LaunchIcon />
          </IconButton>
        </TooltipWithArrow>
      )}
    </Stack>
  );
};
